// extracted by mini-css-extract-plugin
export default {"nav1":"Header1_nav1__79V9L","nav1link":"Header1_nav1link__jmLfD"};